/** Departure-time mode: track "now" (auto-updating) or a user-fixed HH:MM. */
export type TimeMode = 'now' | 'fixed';

const HHMM_RE = /^([01]\d|2[0-3]):[0-5]\d$/;

/** True when `candidate` is a 24-hour `HH:MM` wall-clock time. */
export function isClockTime(candidate: string): boolean {
  return HHMM_RE.test(candidate);
}

/**
 * Reactive departure-time holder. Fixed HH:MM stored verbatim (empty when
 * mode='now'). `toUrlValue()` produces the wire form for URL/API calls.
 */
export class TimeStore {
  mode = $state<TimeMode>('now');
  value = $state('');

  /** Switches to "now" mode and clears any stored HH:MM. */
  setNow(): void {
    this.mode = 'now';
    this.value = '';
  }

  /** Switches to "fixed" mode and stores `hhmm` verbatim (validated at read time). */
  setFixed(hhmm: string): void {
    this.mode = 'fixed';
    this.value = hhmm;
  }

  /**
   * Wire representation: `HH:MM` in fixed mode with a valid value; null in
   * `now` mode OR fixed mode with an invalid value (both silently degrade —
   * the backend reads null as "now").
   */
  toUrlValue(): string | null {
    if (this.mode !== 'fixed') return null;
    return isClockTime(this.value) ? this.value : null;
  }
}
